import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: '404.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class P404Component {

  constructor() { }

}
